export enum VehicleDriverEvaluationCreateStatusType {
  EVALUATION_IS_EXISTS = 'EvaluationIsExists',
  REQUEST_CREATED = 'RequestCreated',
  PHONE_INFORMATION_IS_NOT_FOUND = 'PhoneInformationIsNotFound',
}
